module.exports = {
  "env": "production",
  "isDev": false,
  "noIndex": false,
  "graphloginUrl": "https://login.graphcomment.com",
  "apiUrl": "https://graphcomment.com",
  "wsUrl": "wss://graphcomment.com/websocket",
  "imageUrl": "https://graphcomment.com",
  "yakliUrl": "https://yak.li",
  "integrationUrl": "https://integration.graphcomment.com/graphlogin.js",
  "pyschoPath": "https://www.psychologies.com/psy_polish/look-a-like/",
  "cacheEnabled": false
};
